import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import dayjs from "dayjs";
import moment from "moment";
import queryString from "query-string";

import { get } from "lodash";
import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Input,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  InputAdornment,
} from "@mui/material";
import { Modal } from "react-bootstrap";
import { UserEdit, User, Sms, Edit } from "iconsax-react";
import InputDate from "../../../components/global/InputDate";
import { Link } from "react-router-dom";
import { editGuestDetail, getSalesOrderDetail } from "../actions";
const { URL_PREFIX } = window;

class VF1Step1 extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      isGetDataLoading: false,
      isOpen: false,
      form: {
        name: "",
        email: "",
        dob: "",
        gender: "",
      },
      selectedRow: {},
    };
  }

  componentWillMount() {
    let params = queryString.parse(this.props.location.search);
    this.setState({
      form: {
        name: get(params, "name", ""),
        email: get(params, "email", ""),
        dob: get(params, "dob", ""),
        gender: get(params, "gender", ""),
      },
    });
  }

  render() {
    const { soDetail } = this.props.vf1;
    console.log(soDetail);

    const handleOpen = () => {
      this.setState({ isOpen: true });
    };
    const handleClose = () => {
      this.setState({
        isOpen: false,
        selectedRow: {},
        form: { name: "", email: "", dob: "", gender: "" },
      });
    };

    const guestData = soDetail.guestList.map((v) => {
      const matchingSegments = soDetail.segments.filter(
        (segment) => segment.Guest_ID__c === v.Id
      );
      matchingSegments.sort((a, b) => new Date(a.Start_Date__c) - new Date(b.Start_Date__c));

      return {
        ...v,
        segments: matchingSegments,
      };
    });

    const handleSelectedRow = (row) => {
      this.setState({
        selectedRow: row,
        form: {
          name: row.Guest_FullName__r?.Name,
          email: row.Guest_FullName__r?.Email,
          dob: row.Guest_FullName__r?.Birthdate,
          gender: row.Guest_FullName__r?.Gender__c,
        },
      });
    };

    const changeFormValue = (key, value) => {
      const { form } = this.state;
      form[key] = value;
      this.setState({ form });
    };

    return (
      <>

        <div style={{ margin: "30px" }}>
          <Box sx={{ width: "auto" }}>
            <Typography variant="h4" sx={{ fontWeight: 600, fontSize: "30px" }}>
              Guest Details
            </Typography>
          </Box>
          <Box sx={{ width: "auto", marginTop: "20px" }}>
            <Typography
              variant="text-large"
              sx={{
                color: "#667085",
                fontSize: "18px",
                fontWeight: 300,
              }}>
              Please check your sales order and guest lists to make sure
              everything is correct
            </Typography>
          </Box>

          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              border: "1px solid #EAECF0",
              padding: "24px",
              boxShadow:
                " 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
              borderRadius: "8px",
            }}>
            <Grid container>
              <Grid item md={2.4} sm={4}>
                <Typography
                  sx={{ color: "#101828", fontWeight: 600, fontSize: "16px" }}>
                  Sales Order Detail
                </Typography>
                <Typography
                  sx={{ color: "#101828", fontWeight: 600, fontSize: "16px" }}>
                  Sales Person Name
                </Typography>
                <Typography
                  sx={{ color: "#101828", fontWeight: 600, fontSize: "16px" }}>
                  Contact Name
                </Typography>
              </Grid>
              <Grid item md={2.4} sm={4}>
                <Typography
                  sx={{ color: "#344054", fontWeight: 300, fontSize: "16px" }}>
                  {soDetail.Name || ""}
                </Typography>
                <Typography
                  sx={{ color: "#344054", fontWeight: 300, fontSize: "16px" }}>
                  {soDetail.Account_Name__r?.Name || ""}
                </Typography>
                <Typography
                  sx={{ color: "#344054", fontWeight: 300, fontSize: "16px" }}>
                  {soDetail.Contact_Name__r?.Name || ""}
                </Typography>
              </Grid>
              <Grid item md={2.4} sm={4}>
                <div />
              </Grid>

              <Grid item md={2.4} sm={4}>
                <Typography
                  sx={{ color: "#101828", fontWeight: 600, fontSize: "16px" }}>
                  Number of Guests
                </Typography>
                <Typography
                  sx={{ color: "#101828", fontWeight: 600, fontSize: "16px" }}>
                  Order Date
                </Typography>
              </Grid>
              <Grid item md={2.4} sm={4}>
                <Typography
                  sx={{ color: "#344054", fontWeight: 300, fontSize: "16px" }}>
                  {soDetail.Num_of_Guests__c || ""}
                </Typography>
                <Typography
                  sx={{ color: "#344054", fontWeight: 300, fontSize: "16px" }}>
                  {moment(soDetail.SO_Date__c).format("DD/MMM/YYYY")}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          {/* Guest List */}
          <Box
            sx={{
              marginTop: "30px",
              border: "1px solid #EAECF0",
              padding: "24px",
              boxShadow:
                " 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
              borderRadius: "8px",
              width: "100%",
            }}>
            <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
              <Typography
                sx={{ color: "#101828", fontWeight: 600, fontSize: "16px" }}>
                Guest List
              </Typography>
              <Box
                sx={{
                  borderRadius: "16px",
                  padding: "2px 8px",
                  background: "#EFFCF9",
                  width: "70px",
                  textAlign: "center",
                }}>
                <Typography
                  sx={{
                    color: "#337D96",
                    fontWeight: "500",
                    fontSize: "12px",
                  }}>
                  {`${soDetail?.guestList?.length} guests`}
                </Typography>
              </Box>
            </Box>
            {/* Table Guest List */}
            <Table sx={{ marginTop: "20px", border: "1px solid #EAECF0" }}>
              <TableHead sx={{ background: "#F9FAFB" }}>
                <TableRow
                  sx={{
                    ".MuiTableCell-root.MuiTableCell-head": {
                      fontSize: "12px",
                      color: "#475467",
                      fontWeight: 400,
                    },
                  }}>
                  <TableCell>#</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Date of Birth</TableCell>
                  <TableCell>Gender</TableCell>
                  <TableCell>Type of Accommodation</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <>
                  {guestData.map((data, index) => (
                    <TableRow
                      onClick={() => handleSelectedRow(data)}
                      key={data.Id}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <User
                            size="18px"
                            color="#4AA1B3"
                            style={{ marginRight: "10px" }}
                          />
                          <Typography
                            sx={{
                              display: "flex",
                              alignItems: "flex-end",
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: "#475467",
                            }}>
                            {data.Guest_FullName__r?.Name}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          color: "#475467",
                          fontWeight: 300,
                        }}>
                        {data.Guest_FullName__r?.Birthdate !== null
                          ? moment(data.Guest_FullName__r?.Birthdate).format(
                            "DD/MMM/YYYY"
                          )
                          : "-"}
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            fontSize: "14px",
                            fontWeight: 400,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "16px",
                            background:
                              data.Guest_FullName__r?.Gender__c === "Male"
                                ? "#C7CBF8"
                                : "#E2FCF6",
                            color:
                              data.Guest_FullName__r?.Gender__c === "Male"
                                ? "#00034C"
                                : "#205B79",
                            width: "55px",
                            height: "24px",
                          }}>
                          {data.Guest_FullName__r?.Gender__c || "-"}
                        </Box>
                      </TableCell>
                      {/* TODO: data dapet darimana? */}
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          color: "#475467",
                          fontWeight: 300,
                        }}>
                        {data.segments.map((item) => item.RoomType__c).join(', ')}
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={handleOpen}>
                          <Box
                            sx={{
                              padding: "6px",
                              background: "#FFFFFF",
                              border: " 1px solid #D0D5DD",
                              boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                              borderRadius: "8px",
                              width: "36px",
                              height: "36px",
                            }}>
                            <Edit />
                          </Box>
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              </TableBody>
            </Table>
          </Box>
          <Box sx={{ marginTop: "32px", textAlign: "center" }}>
            <Link
              to={`${URL_PREFIX}/vf1/wizard/guest-allocation`}
              style={{ textDecoration: "none" }}>
              <button
                onClick={() =>
                  localStorage.setItem(
                    "@stepper",
                    JSON.stringify({
                      guestDetail: "done",
                      guestAllocation: "current",
                      guestConfirmation: "undone",
                      guestSummary: "undone",
                    })
                  )
                }
                style={{
                  background: "#2F37B5",
                  border: "1px solid #2F37B5",
                  boxShadow: " 0px 1px 2px rgba(16, 24, 40, 0.05)",
                  borderRadius: "8px",
                  width: "76px",
                  height: "48px",
                }}>
                <Typography
                  sx={{ color: "white", fontWeight: 600, fontSize: "16px" }}>
                  Next
                </Typography>
              </button>
            </Link>
          </Box>
        </div >

        <Modal
          show={this.state.isOpen}
          onHide={handleClose}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <Box sx={{ padding: "24px" }}>
            <Modal.Header closeButton>
              <UserEdit />
              <Modal.Title
                style={{
                  marginTop: "10px",
                  fontWeight: 600,
                  fontSize: "16px",
                }}>
                Edit Guest
              </Modal.Title>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 300,
                  color: "#475467",
                  martinTop: "5px",
                }}>
                Make adjustments to the guest data
              </Typography>
            </Modal.Header>
            <Modal.Body style={{ marginBottom: "24px" }}>
              <Grid container gap={0}>
                <Grid item sm={12}>
                  <FormControl>
                    <InputLabel>Name</InputLabel>
                    <Input
                      type="text"
                      placeholder="Full Name"
                      required
                      startAdornment={
                        <InputAdornment position="start">
                          <User size={22} />
                        </InputAdornment>
                      }
                      name="name"
                      defaultValue={
                        this?.state?.selectedRow?.Guest_FullName__r?.Name
                      }
                      onChange={(e) => changeFormValue("name", e.target.value)}
                    />
                  </FormControl>
                </Grid>
                <Grid item sm={12}>
                  <FormControl>
                    <InputLabel>Email</InputLabel>
                    <Input
                      type="text"
                      placeholder="example@mail.com"
                      required
                      startAdornment={
                        <InputAdornment position="start">
                          <Sms size={22} />
                        </InputAdornment>
                      }
                      name="email"
                      defaultValue={
                        this?.state?.selectedRow?.Guest_FullName__r?.Email
                      }
                      onChange={(e) => changeFormValue("email", e.target.value)}
                    />
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <InputDate
                    label="Date of Birth"
                    onChange={(e) =>
                      changeFormValue("dob", dayjs(e.$d).format("YYYY-MM-DD"))
                    }
                    format={'DD-MMM-YYYY'}
                    value={dayjs(
                      this?.state?.selectedRow?.Guest_FullName__r?.Birthdate
                    )}
                  />
                </Grid>
                <Grid item md={6}>
                  <FormControl sx={{ marginLeft: "5px" }}>
                    <InputLabel>Gender</InputLabel>
                    <Select
                      sx={{ height: "48px" }}
                      defaultValue={
                        this?.state?.selectedRow?.Guest_FullName__r?.Gender__c
                      }
                      onChange={(e) =>
                        changeFormValue("gender", e.target.value)
                      }>
                      <MenuItem sx={{ fontSize: "14px" }} value={"Male"}>
                        Male
                      </MenuItem>
                      <MenuItem sx={{ fontSize: "14px" }} value={"Female"}>
                        Female
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Modal.Body>
            <Modal.Footer>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                }}>
                <Button
                  sx={{
                    width: "290px",
                    height: "44px",
                    background: "#FFFFFF",
                    border: "1px solid #D0D5DD",
                    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    borderRadius: "8px",
                    color: "#344054",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                  onClick={handleClose}>
                  Close
                </Button>
                <Button
                  sx={{
                    marginLeft: "10px",
                    width: "290px",
                    height: "44px",
                    background: "#2F37B5",
                    border: "1px solid #2F37B5",
                    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    borderRadius: "8px",
                    color: "white",
                    fontWeight: 600,
                    fontSize: "12px",
                    ":hover": {
                      background: "#2F37B5",
                      color: "white",
                    },
                  }}
                  onClick={async () => {
                    this.setState({ isLoading: true });
                    await editGuestDetail(
                      this.state.form,
                      this.state.selectedRow.Id,
                      () => {
                        this.props.getSalesOrderDetail();
                      }
                    );
                    this.setState({ isLoading: false });
                    handleClose();
                  }}>
                  {this.state.isLoading ? (
                    <i
                      style={{ color: "white" }}
                      className="fa fa-circle-notch fa-spin fa-2x loading"
                    />
                  ) : (
                    "Save"
                  )}
                </Button>
              </Box>
            </Modal.Footer>
          </Box>
        </Modal>
      </>
    );
  }
}

VF1Step1.propTypes = {
  vf1: PropTypes.object.isRequired,
  // nextStep: PropTypes.func.isRequired,
  // previousStep: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSalesOrderDetail,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  vf1: state.vf1,
});

export default connect(mapStateToProps, mapDispatchToProps)(VF1Step1);
